import { InjectionToken } from '@angular/core';

/**
 * Which app the session is running in ('learner' | 'instructor' | 'admin'). Provide it in each app's
 * `createAppConfig` — see `provideAnalyticsApp`.
 *
 * All three apps share a single Clarity project and a single app-settings.json per environment, and
 * role != app (an admin can impersonate into the learner/instructor app), so this is the only reliable
 * way to tell the apps apart in analytics. It is a DI token rather than a setter call because
 * AnalyticsService decides in its constructor whether to inject the Clarity tag at all — anything set
 * afterwards arrives too late to keep an app out of session recording.
 */
export const ANALYTICS_APP = new InjectionToken<string>('ANALYTICS_APP');

export function provideAnalyticsApp(app: string) {
	return { provide: ANALYTICS_APP, useValue: app };
}
